export const EMAIL_CAMPAIGNS_PAGE_LIMIT = 10;

export enum EmailCampaignType {
    BoosterEmail = 'Booster Email',
    DedicatedFollowerAlert = 'Dedicated Follower Alert',
    DedicatedNewsletter = 'Dedicated Newsletter',
    FeaturedAdUnit = 'Featured Ad Unit',
    LargeAdUnit = 'Large Ad Unit',
    SmallAdUnit = 'Small Ad Unit',
}

export type EditableEmailCampaignType = Exclude<EmailCampaignType, EmailCampaignType.DedicatedFollowerAlert>;

export type EmailCampaign = {
    advertisingNumber: string;
    blastId: number;
    campaign: string;
    campaignEventUuid: string;
    campaignType: EmailCampaignType;
    catalogIds: number[];
    dateSent: string;
    emailUrl: string;
    houseId: number;
    id: number;
    readOnly: boolean;
};

export type EmailCampaignsList = {
    campaigns: EmailCampaign[];
    limit: number;
    offset: number;
    total: number;
};

export type EmailCampaignBody = {
    advertisingNumber?: string;
    blastId: number;
    campaign: string;
    campaignType: EditableEmailCampaignType;
    catalogIds: number[];
    dateSent: string;
    houseId: number;
};

export type UpdateEmailCampaignParams = EmailCampaignBody & {
    emailCampaignId: number;
};

export type GetEmailCampaignsParams = {
    campaign?: string;
    houseId?: number;
    limit?: number;
    offset?: number;
};

export type EmailCampaignsSlice = {
    byId: {
        [emailCampaignId: number]: EmailCampaign;
    };
    campaignIds: number[];
    deleteError: string;
    fetchError: string;
    isDeleting: boolean;
    isLoading: boolean;
    isSaving: boolean;
    saveError: string;
    total: number;
    wasSaveSuccessful: boolean | undefined;
};

export const defaultEmailCampaignsSlice: EmailCampaignsSlice = {
    byId: {},
    campaignIds: [],
    deleteError: '',
    fetchError: '',
    isDeleting: false,
    isLoading: false,
    isSaving: false,
    saveError: '',
    total: 0,
    wasSaveSuccessful: undefined,
};

export enum EmailCampaignRequestError {
    Other = 'An unexpected error occurred. Please try again.',
}
